import { Component, OnInit } from '@angular/core';
import { PerformanceService } from 'src/app/services/performance.service';
import { Chronometer } from 'ngx-chronometer';
import { DateCalculationService } from 'src/app/services/date-calculation.service';
import * as moment from 'moment';
import { UtilisateursService } from 'src/app/services/utilisateurs.service';
import { EncryptionService } from 'src/app/services/encryption.service';
import { take } from 'rxjs/operators';

import * as Excel from 'exceljs';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-performance',
  templateUrl: './performance.component.html',
  styleUrls: ['./performance.component.css']
})
export class PerformanceComponent implements OnInit {

  barData : any;
  dmtMoyenne : any = {
    faible : "",
    moyenne : "",
    forte : ""
  };
  gainPerte : string = "";
  gainPerteColor : number = 0;
  tauxIso : number = 0;

  nbTotal  : number = 0;

  qualite : any;
  options : any = {
    legend: {
      display: false
    },
    tooltips: {
      enabled: true
    },
    plugins : {
      datalabels: {
        /* show value in percents */
        formatter: (value, ctx) => {
          return "";
        },
      }
    }
  };

  dureeParComplexite : any= {
    dureeFaible : "",
    dureeMoyenne : "",
    dureeForte : "",
    totalFaible : 0,
    totalMoyenne : 0,
    totalForte : 0,
  };

  cadence : any = {
    faible : 0,
    moyenne : 0,
    forte : 0
  };

  nbTraiteesOptions : any = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ],
      xAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ]
    },
    plugins : {
      datalabels: {
        color : '#000000',
        font: {
          weight:'bold',
          size: 16
        }
      }
    }
  }

  chrono : Chronometer = new Chronometer();



  fr: any;
  activeIndexTabView = 0;

  valueDate: Date;
  valueSemaine: Date;
  valuMois: Date;
  valuePeriode: Date;

  choosenPers: number = 0;

  perfChoice = [
    {label : 'Modération', value :1},
    {label : 'CQ', value:2},

  ];


  userChoice = [
    {label : 'Filtre OP', value :0},
    {label : '3218', value :3218},
    {label : '3219', value :3219},
    {label : '3220', value :3220},
    {label : '3222', value :3222},
    {label : '3224', value :3224},
    {label : '3225', value :3225},
  ];

  typeFicheChoice = [
    {label: 'Filtre fiches', value: 'toutes'},
    {label: 'INITIALE', value: 'initiales'},
    {label: 'RETOURS', value: 'retours'},
  ]

  chooseType:string = 'toutes';
  canSelectUser:boolean = false;

  perfValue:number = 1;

  constructor(private performanceService : PerformanceService, private dateService : DateCalculationService,  private encryptService:EncryptionService) {}

    ngOnInit(): void {
      this.fr = this.dateService.getFrLocale();
      const date_filtre = this.getDateToday();

      let userParsed =  JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
      
      if(userParsed.id_droit < 3 ) {
        this.canSelectUser = true;
      }
      
      this.loadAllDatas(date_filtre.date_deb, date_filtre.date_fin);

    }

    loadAllDatas(dateDebut:string, dateFin:string) {
      let debut = new Date(dateDebut);
      let fin = new Date(dateFin);
      let depasse = this.dateService.checkIfPlusNDays(debut, fin, 92);
      
      if(!depasse) {
        this.getData(dateDebut, dateFin);
      } else {
        alert("Veuillez choisir une intervalle de date moins longue");
      }
    }


    getDataFromDate() {
      const filtre_date = this.getDateFromCurrentTabView();
      if (filtre_date == null)
      {
        alert('Veuillez selecitonner une date');
        return;
      }
      this.loadAllDatas(filtre_date.date_deb, filtre_date.date_fin);
    }

    async getData(dateDebut:string, dateFin:string) {
      
      let cq  = this.perfValue;
      let isSuperv = false;

      let userParsed =  JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
      
      if(userParsed.id_droit < 3 ) {
        isSuperv = true;
      }

      this.performanceService.getNbTraites(dateDebut, dateFin, cq, isSuperv, this.choosenPers, this.chooseType).subscribe( value => {
        if(value["status"] !== "success"){
          console.log("Une erreur dans la requête:" + value["cause"]);
        }else {
          let results = value["data"];

          this.nbTotal = Number(results.faible) + Number(results.moyenne) + Number(results.forte);

          this.barData = {
            labels: [''],
            datasets : [
              {
                label: 'Faible',
                backgroundColor: '#6495ED',
                borderColor: '#1E88E5',
                data: [results.faible]
              },
              {
                label: 'Moyenne',
                backgroundColor: '#FF8C00',
                borderColor: '#1E88E5',
                data: [results.moyenne]
              },
              {
                label: 'Forte',
                backgroundColor: '#A9A9A9',
                borderColor: '#1E88E5',
                data: [results.forte]
              },
            ]
            
          }
        }
      });

      this.performanceService.getGainPerte(dateDebut, dateFin, cq, isSuperv, this.choosenPers, this.chooseType).subscribe( value => {
        if(value["status"] !== "success"){
          console.log("Une erreur dans la requête:" + value["cause"]);
        }else {
          this.gainPerte = this.dateService.formatSeconds(value['data']);

          if(value['data'] !== undefined && value['data'] !== null) {
              let val = parseInt(value['data']);
              (val < 0 ) ? this.gainPerteColor = 2 : this.gainPerteColor = 1;
          }  else {
            this.gainPerteColor = 0;
          }
        }
      });

      this.performanceService.getDmtMoyenne(dateDebut, dateFin, cq, isSuperv, this.choosenPers, this.chooseType).subscribe( value => {
        if(value["status"] !== "success"){
          console.log("Une erreur dans la requête:" + value["cause"]);
        }else {
          let result = value["data"];
          this.dmtMoyenne.faible = new Date((parseInt(result.faible) * 60 * 1000)).toISOString().substr(11,5);
          this.dmtMoyenne.moyenne = new Date((parseInt(result.moyenne) * 60 * 1000)).toISOString().substr(11,5);
          this.dmtMoyenne.forte = new Date((parseInt(result.forte) * 60 * 1000)).toISOString().substr(11,5);
        }
      });

      this.performanceService.getTauxIso(dateDebut, dateFin, isSuperv, this.choosenPers, this.chooseType).subscribe( value => {
        if(value["status"] !== "success"){
          console.log("Une erreur dans la requête:" + value["cause"]);
        }else {
          console.log(value["data"]);
          this.tauxIso = this.round(value['data'], 2);
          let reste = 100 - this.tauxIso;
          this.qualite = {
            labels: ['A', 'B'],
            datasets: [
              {
                label: '# %',
                data: [this.tauxIso, reste],
                borderWidth: 0,
                backgroundColor: [
                  'royalblue',
                  'antiquewhite'
                ],
                hoverBackgroundColor: [
                  'steelblue',
                ]
              }],
              
          };
        }
      });

      let dmt = await this.performanceService.getDmtMoyenneParComplexite(dateDebut, dateFin, cq, this.choosenPers.toString(), this.chooseType).pipe(take(1)).toPromise();
      this.gererDmtParComplexite(dmt);
    }


    gererDmtParComplexite(dmt){

      if(dmt["status"] !== "success") {
        console.log("Une erreur dans la requête:" + dmt["cause"]);
        alert("Une erreur s'est produite");
      } else {
        let data = dmt["data"];
        this.dureeParComplexite.dureeFaible = new Date((parseInt(data.totalFaible) * 1000)).toISOString().substr(11,8);
        this.dureeParComplexite.dureeMoyenne = new Date((parseInt(data.totalMoyenne)  * 1000)).toISOString().substr(11,8);
        this.dureeParComplexite.dureeForte = new Date((parseInt(data.totalForte)  * 1000)).toISOString().substr(11,8);
        this.dureeParComplexite.totalFaible = data.nbFaible;
        this.dureeParComplexite.totalMoyenne = data.nbMoyenne;
        this.dureeParComplexite.totalForte = data.nbForte;
        if(data.totalFaible > 0) this.cadence.faible = (data.nbFaible / (data.totalFaible/3600)).toFixed(2);
        if(data.totalMoyenne > 0) this.cadence.moyenne = (data.nbMoyenne / (data.totalMoyenne/3600)).toFixed(2);
        if(data.totalForte > 0) this.cadence.forte = (data.nbForte / (data.totalForte/3600)).toFixed(2);
      }
    }


    async exportListeFiches(){
      let date = this.getDateFromCurrentTabView();
      let debut = new Date(date.date_deb);
      let fin = new Date(date.date_fin);
      let depasse = this.dateService.checkIfPlusNDays(debut, fin, 92);

      if(!depasse) {
        let results = await this.performanceService.getListeTraitees(date.date_deb, date.date_fin, this.perfValue, this.choosenPers.toString(), this.chooseType).pipe(take(1)).toPromise();
        this.buildExcel(results['data']);
      } else {
        alert("Veuillez choisir une intervalle de date moins longue");
      }
      
    }


    async buildExcel(liste){
      const workbook = new Excel.Workbook();
      const sheet = workbook.addWorksheet("Liste fiches");
      this.designDetailSheet(sheet);
      this.populateSheet(sheet, liste);

      sheet.views = [
        {state: 'frozen', ySplit: 2}
      ];

      await workbook.xlsx.writeBuffer({useStyles:true})
      .then( (buffer) => {
        FileSaver.saveAs(new Blob([buffer], {type: 'application/octet-stream'}),  'liste.xlsx');
      })
      .catch(err => {
        console.log(err);
        alert("erreur lors de la génération du fichier excel");
      });
    }

    designDetailSheet(sheet:Excel.Worksheet) {

    //=> Génération en-tête première ligne
      sheet.mergeCells("B1:D1");
      sheet.mergeCells("E1:G1");
      sheet.mergeCells("H1:J1");
      sheet.mergeCells("K1:M1");
      sheet.getCell("B1").value = "INITIALE";
      sheet.getCell("E1").value = "R";
      sheet.getCell("H1").value = "R1";
      sheet.getCell("K1").value = "R2";

      sheet.getColumn("A").width = 20;
      sheet.getColumn("B").width = 20;
      sheet.getColumn("C").width = 20;
      sheet.getColumn("D").width = 20;
      sheet.getColumn("E").width = 20;
      sheet.getColumn("F").width = 20;
      sheet.getColumn("G").width = 20;
      sheet.getColumn("H").width = 20;
      sheet.getColumn("I").width = 20;
      sheet.getColumn("J").width = 20;
      sheet.getColumn("K").width = 20;
      sheet.getColumn("L").width = 20;
      sheet.getColumn("M").width = 20;
      sheet.getColumn("N").width = 30;

      ["A1", "B1", "C1", "D1", "E1", "F1", "G1", "H1", "I1", "J1", "K1", "L1", "M1", "N1"].map(
        (currentCell) => {
  
          sheet.getCell(currentCell).fill = {
            type: 'pattern',
            pattern:'solid',
            fgColor:{argb:'ff8c53'}
          };
  
          sheet.getCell(currentCell).font = {
            name: 'Calibri Light',
            size: 12,
            bold: true,
            color : {argb:'ffffff'}
          };

          sheet.getCell(currentCell).alignment = {
            vertical: 'middle',
            horizontal : 'center'
          };
  
          sheet.getCell(currentCell).border = {
            bottom: {style:'thin', color: {argb:'d06517'}},
            top: {style:'thin', color: {argb:'d06517'}},
            left: {style:'thin', color: {argb:'d06517'}},
            right: {style:'thin', color: {argb:'d06517'}},
          };
  
        }
      );

  
      //=> Génération en-tête deuxième ligne
      sheet.getCell("A2").value = "Numéro PTL";
      sheet.getCell("B2").value = "DMT modération";
      sheet.getCell("C2").value = "DMT CQ";
      sheet.getCell("D2").value = "Complexité";
      sheet.getCell("E2").value = "DMT modération";
      sheet.getCell("F2").value = "DMT CQ";
      sheet.getCell("G2").value = "Complexité";
      sheet.getCell("H2").value = "DMT modération";
      sheet.getCell("I2").value = "DMT CQ";
      sheet.getCell("J2").value = "Complexité";
      sheet.getCell("K2").value = "DMT modération";
      sheet.getCell("L2").value = "DMT CQ";
      sheet.getCell("M2").value = "Complexité";
      sheet.getCell("N2").value = "Etat actuel";

      ["A2", "B2", "C2", "D2", "E2", "F2", "G2", "H2", "I2", "J2", "K2", "L2", "M2", "N2"].map(
        (currentCell) => {
  
          sheet.getCell(currentCell).fill = {
            type: 'pattern',
            pattern:'solid',
            fgColor:{argb:'fff2cc'}
          };
  
          sheet.getCell(currentCell).font = {
            name: 'Calibri Light',
            size: 11,
            bold: true,
            color : {argb:'d06517'}
          };

          sheet.getCell(currentCell).alignment = {
            vertical: 'middle',
            horizontal : 'center'
          };
  
          sheet.getCell(currentCell).border = {
            bottom: {style:'thin', color: {argb:'d06517'}},
            top: {style:'thin', color: {argb:'d06517'}},
            left: {style:'thin', color: {argb:'d06517'}},
            right: {style:'thin', color: {argb:'d06517'}},
          };
  
        }
      );

    }


    populateSheet(sheet:Excel.Worksheet, liste) {
      liste.forEach((currentLine, index) => {
        let currentRow = index+3;
        sheet.getCell(`A${currentRow}`).value = currentLine.num_point_accueil;
        sheet.getCell(`B${currentRow}`).value = currentLine.temps_initial;
        sheet.getCell(`C${currentRow}`).value = currentLine.temps_cq_initial;
        sheet.getCell(`D${currentRow}`).value = currentLine.complexite_initial;
        sheet.getCell(`E${currentRow}`).value = currentLine.temps_r;
        sheet.getCell(`F${currentRow}`).value = currentLine.temps_cq_r;
        sheet.getCell(`G${currentRow}`).value = currentLine.complexite_r;
        sheet.getCell(`H${currentRow}`).value = currentLine.temps_r_un;
        sheet.getCell(`I${currentRow}`).value = currentLine.temps_cq_r_un;
        sheet.getCell(`J${currentRow}`).value = currentLine.complexite_r_un;
        sheet.getCell(`K${currentRow}`).value = currentLine.temps_r_deux;
        sheet.getCell(`L${currentRow}`).value = currentLine.temps_cq_r_deux;
        sheet.getCell(`M${currentRow}`).value = currentLine.complexite_r_deux;
        sheet.getCell(`N${currentRow}`).value = currentLine.designation_etat;

        ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N"].map(
          (currentCell) => {
        
            sheet.getCell(currentCell+""+currentRow).font = {
              name: 'Calibri',
              size: 11,
              color : {argb:'2f2f2f'}
            };
      
            sheet.getCell(currentCell+""+currentRow).border = {
              bottom: {style:'thin', color: {argb:'d06517'}},
              top: {style:'thin', color: {argb:'d06517'}},
              left: {style:'thin', color: {argb:'d06517'}},
              right: {style:'thin', color: {argb:'d06517'}},
            };
    
          }
        );
      });
    }
  

    // Fonction pour Multi Range Date
    selectRangeWeek(evt) {
      const start = new Date(evt);
      start.setDate(start.getDate() - start.getDay() + 1);
      this.valueSemaine[0] = start;
      const end = new Date(start);
      end.setDate(start.getDate() + 6);
      this.valueSemaine[1] = end;
    }



    // Recuperation Valeur Date Filtre
    getDateFromCurrentTabView() {
      switch (this.activeIndexTabView) {
        // CALENDAR DATE
        case(0) : {
          const date_string  = moment(this.valueDate).format('YYYY-MM-DD');
          const objectDate = {
            date_deb: date_string,
            date_fin: date_string,
          };
          return objectDate;
          break;
        }
        // CALENDAR SEMAINE
        case(1) : {
          const date_string_Deb  = moment(this.valueSemaine[0]).format('YYYY-MM-DD');
          const date_string_Fin  = moment(this.valueSemaine[1]).format('YYYY-MM-DD');
          const objectDate = {
            date_deb: date_string_Deb,
            date_fin: date_string_Fin, // '2020-09-10'
          };
          // alert(JSON.stringify(objectDate));
          return objectDate;
          break;
        }
        // CALENDAR MOIS
        case(2) : {
          const date_string_Deb  = moment(this.valuMois).format('YYYY-MM-DD');
          const date_string_Fin  = moment(this.valuMois).endOf('month').format('YYYY-MM-DD');
          const objectDate = {
            date_deb: date_string_Deb,
            date_fin: date_string_Fin, // '2020-09-10'
          };
          // alert(JSON.stringify(objectDate));
          return objectDate;
          break;
        }
        // CALENDAR PERIODE
        case(3) : {
          const date_string_Deb  = moment(this.valuePeriode[0]).format('YYYY-MM-DD');
          const date_string_Fin  = moment(this.valuePeriode[1]).format('YYYY-MM-DD');
          let objectDate = {
            date_deb: date_string_Deb,
            date_fin: date_string_Fin,
          };
          if (date_string_Fin === 'Invalid date')
          {
            objectDate = {
              date_deb: date_string_Deb,
              date_fin: date_string_Deb,
            };
          }
          return objectDate;
          break;
        }
      }
    }

    // Recuperation date 
    getDateToday() {
      const date_string_Deb  = moment().format('YYYY-MM-DD');
      const objectDate = {
        date_deb: date_string_Deb,
        date_fin: date_string_Deb, // '2020-09-10'
      };
      // alert(JSON.stringify(objectDate));
      return objectDate;
    }

    //arrondie les chiffres après la virgule
    round (number, decimalPlaces) {
      const factorOfTen = Math.pow(10, decimalPlaces)
      return Math.round(number * factorOfTen) / factorOfTen
    }

}

